import React from 'react';
import PropTypes from 'prop-types';

import SharedFormHeader from './SharedFormHeader';
import Tooltip from '../../../../common/tooltip';
import Input from '../../../../common/input';
import Switch from '../../../../common/checkboxSwitch';

const SharedVendorForm = props => (
  <div className="u-full-width u-p">
    <SharedFormHeader disabled={props.busy || props.pristine || !props.valid} heading={props.heading} />
    <div className="c-inner-wrapper u-p u-inline-block c-po-vendor-form">
      <div className="c-form-title u-mb- o-flexbox o-flexbox--content-align-center o-flexbox--justify-start">
        <span className="c-label--section">Enter vendor details</span>
        <Tooltip className="c-info-tooltip-new--form">
            Adding a vendor allows a vendor to be applied to a product,
            which allows it to be added to Purchase Orders (POs) in the future.
          </Tooltip>
      </div>
      <form id="po-vendor-form" onSubmit={props.handleSubmit(props.submitPoVendor)}>
        <fieldset disabled={props.busy}>
          <div className="layout">
            <div className="layout__item u-1/2">
              <span className="c-label-new">Name</span>
              <Input
                className="c-input c-input--border c-input--v3"
                disabled={!props.canEditProducts}
                name="name"
                type="text"
                placeholder="Vendor name"
              />
            </div>
            <div className="layout__item u-1/2">
              <span className="c-label-new">Email</span>
              <Input
                className="c-input c-input--border c-input--v3"
                disabled={!props.canEditProducts}
                name="email"
                type="text"
                placeholder="vendor@email.com"
              />
            </div>
            <div className="layout__item u-1/2">
              <div className="o-flexbox o-flexbox--content-align-center o-flexbox--justify-start">
                <Switch
                  disabled={!props.canEditProducts}
                  name="enabled"
                  label="Enabled"
                />
                <Tooltip className="c-info-tooltip-new--form">
                    Disabled vendors cannot be applied to products, and therefore used to generate POs.
                    They will not be removed from any past, saved POs.
                  </Tooltip>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
  );

SharedVendorForm.propTypes = {
  busy: PropTypes.bool.isRequired,
  canEditProducts: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitPoVendor: PropTypes.func.isRequired,
};

export default SharedVendorForm;
